import { createContext } from "react";

import type { GtmSdk } from "..";

interface GtmSdkContextValue {
  sdk: GtmSdk;
}

export const GtmContext = createContext<GtmSdkContextValue | undefined>(
  undefined,
);
